import { useMemo } from 'react'
import { browserName, browserVersion, osName, osVersion } from 'react-device-detect'

/**
 * Hook to get device information for authentication
 */
export const useDeviceInfo = () => {
	const deviceInfo = useMemo(
		() => ({
			deviceName: browserName,
			deviceVersion: browserVersion,
			osDevice: `${osName} ${osVersion}`,
			appVersion: 1,
		}),
		[]
	)

	return deviceInfo
}

